import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-catalogs-catalogs-breadcrumb-filter-card',
  templateUrl: './catalogs-catalogs-breadcrumb-filter-card.component.html',
  styleUrls: ['./catalogs-catalogs-breadcrumb-filter-card.component.scss']
})
export class CatalogsCatalogsBreadcrumbFilterCardComponent implements OnInit {

  @Input() catalogs;

  constructor() { }

  ngOnInit() {

  }

}
